import { render, staticRenderFns } from "./FundraisingDetailsParticipants.vue?vue&type=template&id=0745a4f9&"
import script from "./FundraisingDetailsParticipants.vue?vue&type=script&lang=js&"
export * from "./FundraisingDetailsParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports